import { render, staticRenderFns } from "./HomeworkAnswerList.vue?vue&type=template&id=5ff4e860&scoped=true&"
import script from "./HomeworkAnswerList.vue?vue&type=script&lang=js&"
export * from "./HomeworkAnswerList.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkAnswerList.vue?vue&type=style&index=0&id=5ff4e860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff4e860",
  null
  
)

export default component.exports